import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ownerApi = axios.create({
  baseURL: `${BACKEND_URL}/api/admin`,
  withCredentials: true,
});

ownerApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("buddy_owner_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

ownerApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.endsWith("/owner/login")) {
      localStorage.removeItem("buddy_owner_token");
      window.location.href = "/owner/login";
    }
    return Promise.reject(err);
  }
);
